module.exports = __webpack_public_path__ + "img/icon-lock-green-secure.f2cdac09.svg";